<template>
    <div class="app-body">
        <div class="a-flex-rsbc a-ptb-6">
            <span class="a-fs-16 a-fw-700">冻结金额</span>
            <div class="a-flex-rcc">
                <el-button icon="el-icon-upload2" class="s-btn-exp" @click="exportfile">导出明细</el-button>
            </div>
        </div>
        <el-card class="el-main">
            <le-search-form @reset="handlerRest" @search="handlerSearch" :canPackUp="false" id="leSearch">
                <div class="a-flex-rfsc a-ptb-12">
                    <div class="s-search-label a-flex-rfec">
                        <span>日期范围</span>
                    </div>
                    <el-date-picker
                        ref="dateRange"
                        class="freeze-date-range a-ml-10"
                        v-model="dateRange"
                        type="daterange"
                        unlink-panels
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :default-time="['00:00:00', '23:59:59']"
                        :clearable="false"
                        :picker-options="pickerOptions"
                        @change="onDateChange" />
                </div>
            </le-search-form>
            <le-pagview ref="freezeAmount" @setData="setTableData" :pagerCount="5" :pageParam="pageParam" :isFixed="true" :tableRef="$refs.freezeAmountList">
                <el-table
                    ref="freezeAmountList"
                    :data="tableData"
                    :highlight-current-row="true"
                    v-sticky="{ top: 0, parent:'.el-card__body' }"
                    style="width: 100%">
                    <el-table-column prop="changeDate" label="日期" min-width="140">
                        <template slot-scope="{ row }">
                            <span>{{ row.changeDate ? row.changeDate.split(' ')[0] : '-' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="businessType" label="类型" min-width="120">
                        <template slot-scope="{ row }">
                            <span>{{ row.businessType | initDic(walletBusinessTypeDic) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="changeAmountShow" label="冻结变动" min-width="140">
                        <template slot-scope="{ row }">
                            <span>￥{{ util.numFormat(row.changeAmountShow) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="afterBalance" label="冻结余额" min-width="140">
                        <template slot-scope="{ row }">
                            <span>￥{{ util.numFormat(row.afterBalance) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="mark" label="备注" min-width="200">
                        <template slot-scope="{ row }">
                            <span>{{ row.mark || '-' }}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </le-pagview>
        </el-card>
    </div>
</template>
<script>
import util from '../../utils/util'
export default {
    data () {
        return {
            tableData: [],
            util: util,
            dateRange: [
                this.$getDay.getTodayBeforeDays(29) + ' 00:00:00',
                this.$getDay.getTodayBeforeDays(0) + ' 23:59:59'
            ],
            pageParam: {
                url: this.$Config.apiUrl.getFrozenAmountPage,
                method: "post",
                params: {
                    startDate: this.$getDay.getTodayBeforeDays(29) + ' 00:00:00',
                    endDate: this.$getDay.getTodayBeforeDays(0) + ' 23:59:59'
                },
                freshCtrl: 1,
            },
            pickerOptions: {
                disabledDate: (time) => {
                    const today = new Date()
                    today.setHours(0, 0, 0, 0)
                    const date = new Date(time)
                    date.setHours(0, 0, 0, 0)
                    return date.getTime() > today.getTime()
                }
            },
            walletBusinessTypeDic: []
        }
    },
    mounted () {
        this.$getDic('walletBusinessType').then(res => { this.walletBusinessTypeDic = res })
    },
    methods: {
        setTableData (data) {
            this.tableData = data
        },
        onDateChange (val) {
            if (!val || !val[0] || !val[1]) return
            this.pageParam.params.startDate = val[0].split(' ')[0] + ' 00:00:00'
            this.pageParam.params.endDate = val[1].split(' ')[0] + ' 23:59:59'
        },
        syncDateParams () {
            if (this.dateRange && this.dateRange[0] && this.dateRange[1]) {
                this.pageParam.params.startDate = this.dateRange[0].split(' ')[0] + ' 00:00:00'
                this.pageParam.params.endDate = this.dateRange[1].split(' ')[0] + ' 23:59:59'
            }
        },
        handlerRest () {
            const startDate = this.$getDay.getTodayBeforeDays(29) + ' 00:00:00'
            const endDate = this.$getDay.getTodayBeforeDays(0) + ' 23:59:59'
            this.dateRange = [startDate, endDate]
            this.pageParam.params = { startDate, endDate }
            this.handlerSearch()
        },
        handlerSearch () {
            this.syncDateParams()
            this.$refs['freezeAmount'].pageNum = 1
            this.pageParam.freshCtrl++
        },
        exportfile () {
            this.syncDateParams()
            const startDate = this.pageParam.params.startDate
            const endDate = this.pageParam.params.endDate
            this.$exfile({
                code: 63,
                fileName: startDate.split(' ')[0] + ' 至 ' + endDate.split(' ')[0] + ' 冻结余额变动表',
                startTime: startDate.split(' ')[0],
                endTime: endDate.split(' ')[0],
                params: {
                    ...this.pageParam.params,
                    startDate,
                    endDate
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.freeze-date-range {
    width: 376px;
}
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 0 !important;
    height: 0 !important;
}
/deep/ .el-table__fixed, /deep/ .el-table__fixed-right{
    height: 100% !important;
}
</style>
